import React, {useState, useCallback, useMemo} from 'react';
import base_url, {urlSearchParams} from '../../../baseUrls';
import {ThemeProvider, Box, LinearProgress, CircularProgress, Typography, Button, Grid, Divider, Backdrop} from '@mui/material';
import {useForm, FormProvider} from 'react-hook-form';
import NavBar from '../../../pieces/navbar/navbar';
import ModalWrapper, {ModalContentWrapper} from '../../../pieces/modals/modalWrapper';
import CustomFormBlock from '../../../pieces/inputs/formBlock';
import {inputTypes} from '../../../pieces/inputs/formInput';
///import UserModal from '../../../pieces/modals/userModal';
import * as allConstants from '../../../constants/allConstants';
import {NewPermissionGate} from '../../../permissions/permissionGate';
import {contractorUserPageRules, CONTRACTOR_ELEMENTS} from '../../../permissions/contractorUserPageAccessControl';
import AllServiceTitanJobGrid from '../allServiceTitanJobGrid';
import myTheme from '../../../styles/myStyles';
import DisplayListsPageWrapper from '../../wrappers/displayListsPageWrapper';
//import SetCompanyAdmin from '../../users/setCompanyAdmin';
import ListPageHeader from '../../../pieces/listPageHeader';
import usePagination from '../../../hooks/usePagination';
import {useGridViewState} from '../../../hooks/useGridViewState';
import AccessDenied from '../../misc/accessDenied';
import {globalUseClasses} from '../../../styles/globalClasses';
import {useDispatch} from 'react-redux';
//import actions from '../../../redux/actions';
import {companyAndUserUtils} from '../../../utils/companyAndUserUtils';
import axios from 'axios';
import ApiUtils from '../../../utils/apiUtils';
import {useNavigate} from 'react-router-dom';
import {useGotIt} from '../../../hooks/useGotIt';

export const ServiceTitanJob  = (props)=> {

  //console.log('Service Titan Job =****');
  //console.log(props);
  
  const [isLoading, setIsLoading ] = useState(false);
  const [showGetJobsModal, setShowGetJobsModal] = useState(false);
  const viewController = useGridViewState();
  //const dispatch = useDispatch();
  //const classes = globalUseClasses();
  const pagination = usePagination();
  const gotItPopup = useGotIt();
  const getJobsForm = useForm({
    defaultValues: {
      jobNumber: ''
    }
  });
  //const company = useSelector(state => state.company);
  //const navigate = useNavigate();

  const tenantId = props?.companyData?.serviceTitan?.tenantId;
  const companyId = props?.companyData?.id;

  const fetchParams = useMemo(
    () => ({
      url: `${base_url.api}companies/get-tenant-jobs`,
      respKey: 'stJobs',
      options: {tenantId, companyId},
    }),
    [tenantId, companyId],
  );

  if(!NewPermissionGate({
    user: viewController.user,
    elementPermissions: contractorUserPageRules[CONTRACTOR_ELEMENTS.viewPage]
  })) {
    return <AccessDenied/>;
  }

  const getNewTenantJobs = async (jobId, stJobNumber = null) => {

    setIsLoading(true);
    const url = `${base_url.api}companies/get-tenant-jobs-manually`;
    
    let requestParams = { tenantId: props?.companyData?.serviceTitan?.tenantId ?? 0,
                          stJobNumber: stJobNumber ?? "",
                          id: jobId ? parseInt(jobId) : 0 };

    const authToken = await ApiUtils.getAccessToken(); 

    let axiosConfig = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: authToken,
      }
    };
    await axios.post(url, JSON.stringify(requestParams), axiosConfig);
    
    setIsLoading(false);
    setShowGetJobsModal(false);
    getJobsForm.reset();
    gotItPopup.setShow(`Please wait for a minute or two and click on "Refresh Grid" button to see new jobs`);
  }

  const handleOpenGetJobsModal = () => {
    setShowGetJobsModal(true);
  };

  const handleCloseGetJobsModal = () => {
    setShowGetJobsModal(false);
    getJobsForm.reset();
  };

  const handleGetSpecificJob = async () => {
    const jobNumber = getJobsForm.getValues('jobNumber');
    if (!jobNumber || jobNumber.toString().trim() === '') {
      return;
    }

    try {
      setIsLoading(true);
      const payload = {
        tenant_id: props?.companyData?.serviceTitan?.tenantId,
        job_number: jobNumber.toString().trim(),
      };

      const x = await ApiUtils.makeApiCall('POST', '/jobs/create-from-service-titan', JSON.stringify(payload));

      setShowGetJobsModal(false);
      getJobsForm.reset();

      if (x?.status === 'success') {
        const createdJobNumber = x?.data?.job?.job_number;
        gotItPopup.setShow(`Service Titan job${createdJobNumber ? ` #${createdJobNumber}` : ''} created successfully.`);
        viewController.refreshGrid();
      } else {
        gotItPopup.setShow(x?.message || 'Failed to create Service Titan job.');
      }
    }
    catch (e) {
      console.log('error on creating specific service titan job.', e);
      gotItPopup.setShow('Failed to create Service Titan job.');
    }
    finally {
      setIsLoading(false);
    }
  };

  const handleGetAllJobs = () => {
    getNewTenantJobs(null);
  };
  
  const refreshGrid = () => {
    viewController.refreshGrid();
    //gotItPopup.setShow('Update Grid View!');
  }

  const getAdditionalButtons = ()=> {
      let buttons = [];

      if (props?.companyData?.serviceTitan?.tenantId != null) {
        buttons.push(
          {
            key: 1,
            label: `Get New Jobs`,
            variant: 'outlined',
            color: 'primary',
            onClick: handleOpenGetJobsModal,
          },
        );
      };
      buttons.push(
        {
          key: 2,
          label: `Refresh Grid`,
          variant: 'outlined',
          color: 'primary',
          onClick: refreshGrid,
        }
      );
      return buttons;
  };

  const headerComponent = <ListPageHeader header={'Service Titan Jobs'}
    viewController={viewController}
    //addHandler={handleAddUserOpen}
    totalItems={pagination.totalItemsCount}
    showAddButton = {false} 
    additionalButtons={getAdditionalButtons()}
  >
    {pagination.ItemsController}
  </ListPageHeader>;

  return (
    viewController.RenderElement(
      <>
        <NavBar/>
        <ThemeProvider theme={myTheme}>
          {gotItPopup.PopUp()}
          <Backdrop
            open={isLoading}
            sx={{
              color: '#fff',
              flexDirection: 'column',
              gap: 2,
              zIndex: (theme) => theme.zIndex.modal + 1,
            }}
          >
            <CircularProgress variant="indeterminate" color="success" />
            <Typography variant="h6">
              Please wait!
            </Typography>
          </Backdrop>
          {showGetJobsModal && 
            <ModalWrapper
              open={showGetJobsModal}
              modalName={'get-new-jobs'}
              customStyle={{minHeight: 'auto'}}
              preventScroll={true}
              width={{xs: '98%', sm: '500px'}}
              padding={4}
            >
              <ModalContentWrapper handleClose={handleCloseGetJobsModal} header="Get New Jobs">
                <FormProvider {...getJobsForm}>
                  <Box sx={{display: 'flex', flexDirection: 'column', gap: 3}}>
                    {/* Single Job Section */}
                    <Box>
                      <Grid container>
                        <Grid item xs={12}>
                          <CustomFormBlock
                            field={{api_name: 'jobNumber', required: false, label: 'Service Titan Job Number', display_label: 'Service Titan Job Number'}}
                            inputType={inputTypes.text}
                            fullWidth
                            isEditable={true}
                            renderLabel={true}
                            viewMode={false}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={handleGetSpecificJob}
                            disabled={!getJobsForm.watch('jobNumber') || getJobsForm.watch('jobNumber')?.toString().trim() === ''}
                          >
                            Get Specific Job
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                    <Divider />

                    {/* All Jobs Section */}
                    <Box>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={handleGetAllJobs}
                      >
                        Get All Jobs
                      </Button>
                    </Box>
                  </Box>
                </FormProvider>
              </ModalContentWrapper>
            </ModalWrapper>
          }
          <Box> 
            <DisplayListsPageWrapper headerComponent={headerComponent}>
              <AllServiceTitanJobGrid viewController={viewController}
                  fetchParams={fetchParams}
                  setIsLoading={setIsLoading}
                  pagination={pagination}/>
              {pagination.PageController}
            </DisplayListsPageWrapper>
          </Box>
        </ThemeProvider>
      </>
    )
  );
};

// ServiceTitanNotEmp.propTypes = companyPropTypes;
// ServiceTitanNotEmp.defaultProps = companyDefaultProps;
